import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const webNavigate = (weblink) => {
    window.open(weblink, "_blank");
  };




  return (
    <div className="bg-[#F5F3EE] py-3 px-4 min-[600px]:px-1">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        {/* Left Side */}
        <div className="flex flex-wrap items-center gap-4 text-xs md:text-sm font-avenir text-gray-800">
          <span className="cursor-default font-semibold">© Recess Learning, Inc.</span>

          <span
            onClick={() => webNavigate("https://recesslibrary.com/")}
            className="flex items-center gap-1 cursor-pointer hover:text-blue-600 font-semibold"
          >
            <img
              src={require("../../../Assets/images/lib.png")}
              alt="Learn More"
              className="w-4 h-4 mb-1 md:mb-0"
            />
            Library
          </span>

          <span
            onClick={() => webNavigate("https://www.recess.education")}
            className="flex items-center gap-1 cursor-pointer hover:text-blue-600 font-semibold"
          >
            <img
              src={require("../../../Assets/images/email.png")}
              alt="Get in Touch"
              className="w-4 h-4 mb-1 md:mb-0"
            />
            Get in Touch
          </span>

          <span
            // onClick={() => webNavigate("https://www.recess.education/terms-and-conditions")}
            onClick={() => webNavigate("https://www.hub.recess.education/terms-and-conditions")}
            className="flex items-center gap-1 cursor-pointer hover:text-blue-600 font-semibold"
          >
            <img
              src={require("../../../Assets/images/termsandconditions.png")}
              alt="Terms"
              className="w-4 h-4 mb-1 md:mb-0"
            />
            Terms & Conditions
          </span>

          <span
            // onClick={() => webNavigate("https://www.recess.education/privacy-policy")}
            onClick={() => webNavigate("https://www.hub.recess.education/privacy-policy")}
            className="flex items-center gap-1 cursor-pointer hover:text-blue-600 font-semibold"
          >
            <img
              src={require("../../../Assets/images/policy.png")}
              alt="Policy"
              className="w-4 h-4 mb-1 md:mb-0"
            />
            Privacy Policy
          </span>
        </div>

        {/* Right Side */}
        <div className="text-xs md:text-sm text-gray-800 font-avenir font-semibold flex items-center gap-1 mt-2 md:mt-0">
          <img
            src={require("../../../Assets/images/learnatrecess.png")}
            alt="Learn at Recess"
            className="w-4 h-4 mb-1 md:mb-0"
          />
          Learn at Recess.
        </div>
      </div>
    </div>
  );
};

export default Footer;
